import { render, staticRenderFns } from "./SurveyArea.vue?vue&type=template&id=54be54b0&scoped=true"
import script from "./SurveyArea.vue?vue&type=script&lang=js"
export * from "./SurveyArea.vue?vue&type=script&lang=js"
import style0 from "./SurveyArea.vue?vue&type=style&index=0&id=54be54b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be54b0",
  null
  
)

export default component.exports